import * as T from "@radix-ui/react-tooltip";
import type { ReactNode } from "react";
import { Kbd } from "./Kbd";
import s from "./Tooltip.module.css";

export function TooltipProvider({ children }: { children: ReactNode }) {
  // After the first tooltip, the next ones show instantly (no delay, no animation), like a native toolbar.
  return (
    <T.Provider delayDuration={500} skipDelayDuration={400}>
      {children}
    </T.Provider>
  );
}

export interface TooltipProps {
  content: ReactNode;
  shortcut?: string;
  side?: "top" | "right" | "bottom" | "left";
  children: ReactNode;
}

export function Tooltip({ content, shortcut, side = "bottom", children }: TooltipProps) {
  return (
    <T.Root>
      <T.Trigger asChild>{children}</T.Trigger>
      <T.Portal>
        <T.Content className={s.content} side={side} sideOffset={6} collisionPadding={8}>
          {content}
          {shortcut && <Kbd className={s.kbd}>{shortcut}</Kbd>}
        </T.Content>
      </T.Portal>
    </T.Root>
  );
}
